export default {
  categoryDatabase: 'Database Kategori',
  searchText: 'Cari Nama Kategori',
  photo: 'Foto',
  createCategory: 'Buat Kategori',
  editCategory: 'Ubah Kategori',
  delete: 'Hapus kategori ini',
  name: 'Nama kategori',
  subCategoryName: 'Nama sub kategori',
  tambahSubCategori: 'Tambah sub kategori',
  deleteConfirmMessage: 'Apakah anda yakin ingin menghapus kategori ini? sub kategori juga akan terhapus',
  categoryDeletedMessage: 'Kategori berhasil dihapus',
}
